import React from "react";

import './ConfirmDialog.scss'
import {Modal} from "@carbon/react";
import PropTypes from "prop-types";

const ConfirmDialog = (props) => {
  const open = props.openState
  const setOpen = props.setOpenState
  const isDanger = props.isDanger !== undefined ? props.isDanger : true
  return (
    <Modal
      open={open}
      danger={isDanger}
      modalHeading={props.heading}
      modalLabel="Conferma azione"
      primaryButtonText={props.primaryButtonText}
      onRequestSubmit={props.onRequestSubmit}
      onRequestClose={() => {
        setOpen(false)
      }}
      secondaryButtonText="Annulla"
    />
  )
}

ConfirmDialog.propTypes = {
  openState: PropTypes.bool.isRequired,
  setOpenState: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
  primaryButtonText: PropTypes.string.isRequired,
  onRequestSubmit: PropTypes.func.isRequired,
  isDanger: PropTypes.bool,
}

export default ConfirmDialog